import { render, staticRenderFns } from "./MedicalLeaveList.vue?vue&type=template&id=4e990380"
import script from "./MedicalLeaveList.vue?vue&type=script&lang=js"
export * from "./MedicalLeaveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports